export default "__VITE_PUBLIC_ASSET__f293fff5__"